import { atom } from 'jotai'

// ============================================
// Address Types
// ============================================

export type TMainAddress = {
    address1?: string
    address2?: string
    city?: string
    state?: string
    zip?: string
    country?: string
}

// ============================================
// Licenses Response Types
// ============================================

export type TLicensesResponse = {
    items: TLicensesResponseItem[]
}

export type TLicensesResponseItem = {
    birthDate: string
    depositBankAccount: {
        accountHolder: string
        accountNumber: string
        bankName: string
        branchName: string
    }
    enroller: {
        highestRankShort: string
        id: {
            unicity: string
        }
    }
    humanName: { 
        firstName: string
        fullName: string 
        lastName: string
    }
    id: { 
        unicity: string 
    }
    identification: { 
        documentId: string 
    }
    taxTerms: {
        taxId: string
    }
}

// ============================================
// Profile Response Types
// ============================================

export type TProfileResponse = {
    href: string
    unicity: string
    humanName: { fullName: string }
    email: string
    mobilePhone: string
    mainAddress: TMainAddress
    joinDate: string
    status: string
    type: string
    cumulativeMetricsProfile: { highestRankShort: string }
    sponsor: { 
        href: string
        id: { unicity: string }
        humanName: { 
            firstName: string
            lastName: string
            fullName: string 
        } 
    }
}

// ============================================
// View BA Details Types
// ============================================

export type TViewBADetails = {
    fullName: string
    distributorId: string
    birthDate: string
    taxId: string
    email: string
    phoneNumber: string
    AddressOfResidence: string
    dateOfJoin: string
    permanentAddress: string
    status: string
    placeOfResidenceRegistration: string
    workPermitPhoneNumber: string
    bankName: string
    bankAccountNumber: string
    rank: string
    sponsorId: string
    nameOfSponsor: string
    rankOfSponsor: string
}

export const defaultDetails: TViewBADetails = {
    fullName: '-',
    distributorId: '-',
    birthDate: '-',
    taxId: '-',
    email: '-',
    phoneNumber: '-',
    AddressOfResidence: '-',
    dateOfJoin: '-',
    permanentAddress: '-',
    status: '-',
    placeOfResidenceRegistration: '-',
    workPermitPhoneNumber: '-',
    bankName: '-',
    bankAccountNumber: '-',
    rank: '-',
    sponsorId: '-',
    nameOfSponsor: '-',
    rankOfSponsor: '-'
}

// ============================================
// Atoms
// ============================================

export const viewBADetailsAtom = atom<TViewBADetails>(defaultDetails)
export const viewBADetailsIsLoadingAtom = atom(false)
export const viewBADetailsErrorAtom = atom('')
